import { Component, Input, OnInit, } from '@angular/core';
import { take } from 'rxjs/operators';
import { TRADE_MARKET_ADDRESS } from 'src/app/angular-wallet-base/constants';
import { AppModeService, } from 'src/app/angular-wallet-base/services/app-mode.service';
import { getSideMenuStatus, } from 'src/app/angular-wallet-base/store/appSettings';
import { ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { AppState } from '../../../angular-wallet-base/store/appState';
import { CancelOrderComponent } from './cancel-order/cancel-order.component';
import { SubscriptionListenerComponent } from 'src/app/angular-wallet-base/SubscriptionListenerComponent';
import { OneInchService } from 'src/app/angular-wallet-base/services/one-inch.service';
import { getTradeOrdersLoadedState } from 'src/app/angular-wallet-base/store/wallet';
import { GetTradeOrdersAction } from 'src/app/angular-wallet-base/actions/wallet.actions';
import { Logger } from 'src/app/angular-wallet-base/services/logger.service';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss'],
})
export class OrdersComponent extends SubscriptionListenerComponent implements OnInit {

  @Input() items: any[];
  @Input() usdcFiatVaule: number;

  public isDesktopMode: boolean;
  public markets = TRADE_MARKET_ADDRESS;
  public tradeOrdersProgress = false;
  public loadedAllOrders = false;

  constructor(
    public appMode: AppModeService,
    protected store: Store<AppState>,
    private modalController: ModalController,
    private oneInchService: OneInchService
  ) {
    super(store);
    this.appMode.isDesktopMode.subscribe((mode) => (this.isDesktopMode = mode));
  }

  ngOnInit() {
    this.subscriptions.add(
      this.oneInchService.orderHistoryProgress.subscribe(status => {
        this.tradeOrdersProgress = status;
      })
    );
    this.subscriptions.add(
      this.store.select(getTradeOrdersLoadedState).subscribe(status => {
        this.loadedAllOrders = status;
      })
    );
  }

  loadMore() {
    if(!this.tradeOrdersProgress) {
      Logger.info('loading more .  . .');
      this.store.dispatch(new GetTradeOrdersAction());
    }
  }

  expandCard(index) {
    this.items[index].isExpand = !this.items[index].isExpand;
  }

  async cancelOrder(order) {
    const sideMenuHidden = await this.store.select(getSideMenuStatus).pipe(take(1)).toPromise();
    let cssClass = '';
    cssClass += (this.isDesktopMode) ? 'logout-modal-desktop' : 'logout-modal';
    cssClass += (!sideMenuHidden && this.isDesktopMode) ? ' with-side-menu' : '';
    const modal = await this.modalController.create({
      component: CancelOrderComponent,
      cssClass,
      initialBreakpoint: (this.isDesktopMode) ? undefined : 0.6,
      breakpoints: (this.isDesktopMode) ? undefined : [0, 0.45, 0.6, 1],
      componentProps: {
        order
      },
      backdropDismiss: false,
      id: 'cancel-trade-order'
    });
    await modal.present();
  }
}